import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Settings::SubuserModalForm\n  @subuser={{@model.subuser}}\n  @urlGroups={{@model.urlGroups}}\n  @onClose={{this.transitionToUsers}}\n/>")